module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_waso_studio-989a90fd848a38edd65bb954058365ff.webp";